import './App.css';
import Game from './Game';

function App() {
  return (
    <div className="App">
      <Game />
    </div>
  );
}

export default App;
